import React from 'react';
import { StyleSheet, View, Linking, Text } from 'react-native';
import Colors from '../constants/Colors';
import { MaterialIcons } from '@expo/vector-icons';
import FilledButton from '../components/FilledButton';
import Plentiful from '../constants/Plentiful';
import { useLocalization } from '../store/utils/useLocalization';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.primaryColor,
    padding: 30,
    gap: 15,
  },
  header: {
    color: Colors.white,
    fontWeight: 'bold',
    fontSize: 24,
    textAlign: 'center',
  },
  text: {
    color: Colors.white,
    fontWeight: 'bold',
  },
  logo: {
    width: 100,
    height: 100,
  },
});

type ErrorScreenProps = {
  restartCallback: () => void;
};

export const ErrorScreen = (props: ErrorScreenProps) => {
  const { translation } = useLocalization();

  return (
    <View style={styles.container}>
      <MaterialIcons name={'error-outline'} size={96} color={Colors.warningBackground} />
      <Text style={styles.header}>{translation.error_screen_header}</Text>
      <Text style={styles.text}>{translation.error_screen_message}</Text>
      <FilledButton
        onPress={props.restartCallback}
        label={translation.restart_app}
        color={Colors.mediumBlue}
        full={true}
      />
      <FilledButton
        onPress={() => Linking.openURL(`mailto:${Plentiful.SUPPORT_EMAIL}`)}
        label={translation.email_support}
        color={Colors.mediumBlue}
        full={false}
      />
    </View>
  );
};
